module.exports = __webpack_public_path__ + "img/29_45.1acd45d0.png";